// extracted by mini-css-extract-plugin
export default {"main":"styles_main__E4Gct","container2":"styles_container2__Xc25F","events":"styles_events__xjuJX","event_container":"styles_event_container__fxgwq"};